import { render, staticRenderFns } from "./InputUpload.vue?vue&type=template&id=4b01878f&scoped=true&"
import script from "./InputUpload.vue?vue&type=script&lang=js&"
export * from "./InputUpload.vue?vue&type=script&lang=js&"
import style0 from "./InputUpload.vue?vue&type=style&index=0&id=4b01878f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b01878f",
  null
  
)

export default component.exports